import styled from 'styled-components';

export const StyledRoot = styled.div`
  display: 'flex';
`;
